// 配电柜列表
// 2020-04-16 lvpeng
import React, { Component } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import { Modal } from "antd";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import PowerBoxDetail from "./PowerBoxDetail";
import FormCore from "../../../components/display/form/formCore";
import { getPowerBoxList } from "../../../fetch/fetchApi";
@connect((state) => state)
class PowerBoxList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.isFirst = true;
    this.state = {
      formConfig: null,
      detailData: {},
      internationalization: this.props.intl.messages.powerBoxList,
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  componentWillMount() {
    // 初始定义表格数据
    this.initGrid();
    // 清除数据
    localStorage.clear();
  }

  initGrid() {
    this.queryStubId = "";
    this.queryStubName = "";
    this.queryMeterModuleId = "";

    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.queryStubId = window.LayoutTab.tabParam.stubId ? window.LayoutTab.tabParam.stubId : "";
      this.queryStubName = window.LayoutTab.tabParam.stubGroupName
        ? window.LayoutTab.tabParam.stubGroupName
        : "";
      this.queryStubGroupId = window.LayoutTab.tabParam.stubGroupId
        ? window.LayoutTab.tabParam.stubGroupId
        : "";
      this.queryMeterModuleId = window.LayoutTab.tabParam.meterModuleId
        ? window.LayoutTab.tabParam.meterModuleId
        : "";
    }
    console.log(this.queryStubGroupId);

    this.setState({
      formConfig: this.setFormConfig(),
      tableConfig: this.setTableConfig(),
    });
    this.isFirst = false;
  }

  setTableConfig = () => {
    const tableConfig = {
      tableColumns: [
        {
          name: this.state.internationalization.title3,
          message: (
            <div className="mcjs" style={{ width: "350px", maxWidth: 500 }}>
              <p style={{ textAlign: "center" }}>
                <b>抄表模块编码规则</b>
              </p>
              <p>
                <b>抄表模块采用9位纯数字编码：</b>
              </p>
              <p style={{ fontSize: 14 }}>
                <b>1.开头+8位数字：</b>用于ERP上线的，现场没安装抄表模块的虚拟编号
              </p>
              <p style={{ fontSize: 14 }}>
                <b>2.开头+8位数字：</b>2G智能抄表模块
              </p>
              <p style={{ fontSize: 14 }}>
                <b>3.开头+8位数字：</b>用于ALM上线的，现场没安装抄表模块的虚拟编号
              </p>
              <p style={{ fontSize: 14 }}>
                <b>4.开头+8位数字：</b>4G cat1智能抄表模块
              </p>
              <p style={{ fontSize: 14 }}>
                <b>5.开头+8位桩编号：</b>
                485方案编号（需要桩端软件按既定的编码上报数据，要与桩端沟通）
              </p>
            </div>
          ),
          key: "meterModuleId",
          colType: "textCol",
          align: "left",
        },
        {
          name: this.state.internationalization.title2,
          key: "stubGroupName",
          align: "left",
          colType: "textCol",
          render: (value) => {
            if (value.length > 10) {
              return <span title={value}>{value || "--"}</span>;
            } else if (value) {
              return value;
            } else {
              return "--";
            }
          },
        },
        {
          name: this.state.internationalization.wz1, // '固件信息',
          key: "frameWork",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            if (value !== "--" && value && row.updateType) {
              return `${row.updateType.replace(/(^\s*)|(\s*$)/g, "")}-${value.replace(
                /(^\s*)|(\s*$)/g,
                "",
              )}`;
            } else {
              return "--";
            }
          },
        },
        {
          name: this.state.internationalization.wz2, // '电表编号',
          key: "meterId",
          align: "left",
        },
        {
          name: this.state.internationalization.title8,
          key: "ratedPower",
          colType: "numCol",
          align: "center",
          width: 200,
        },
        {
          name: this.state.internationalization.action,
          key: "action",
          colType: "action", // 操作列，可定义多种操作。
          fix: "right",
          width: 80,
          align: "center",
          actionMap: [
            {
              type: "href",
              actionName: this.state.internationalization.title9, // '配电柜详情',
              handler: (res) => {
                this.powerboxInfoData = res;
                this.modalVisibleAction("seeDetailVisible", true);
                this.setState({
                  seeDetailVisible: true,
                });
              },
            },
            {
              type: "href",
              actionName: this.state.internationalization.title10,
              handler: (record) => {
                // localStorage.meterModuleId = record.meterModuleId;
                this.openTab(
                  {
                    // keyId: `stub`,
                    meterModuleId: record.meterModuleId,
                  },
                  {
                    key: "0102",
                    titleText: this.state.internationalization.title11,
                  },
                );
              },
            },
          ],
        },
      ],
      tableParam: {
        pageCount: 10,
      },
      tableInfo: {
        hasRow: !1, // 是否显示checkbox
      },
      tableChange: () => {
        // grid翻页页，排序， 筛选过滤时触发
        console.debug("change");
      },
      autoRefresh: !1, // 设置为true 直接加载grid数据
      dataApi: getPowerBoxList,
      tableKey: "powerBoxTable",
    };
    return tableConfig;
  };

  setFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          inputType: "text",
          param: {
            name: "meterModuleId", // 提交的参数
            type: "string",
          },
          labelName: this.state.internationalization.title1, // '配电柜编号',
          placeholder: this.state.internationalization.placeholder1, // '请输入配电柜编号'
          defaultValue: this.queryMeterModuleId,
        },
        {
          type: "input",
          inputType: "text",
          placeholder: this.state.internationalization.placeholder2,
          param: {
            name: "stubGroupName",
            type: "string",
          },
          labelName: this.state.internationalization.title2, // '电站名称:',
          defaultValue: this.queryStubName,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.state.internationalization.btn1,
              // icon: 'search'
            },
          ],
        },
      ], // 设置表单元素
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        stubGroupName: this.queryStubName,
        stubGroupId: this.queryStubGroupId,
        meterModuleId: this.queryMeterModuleId,
      },
      autoLoadGrid: 1, // 设置为false不触发加载grid
      context: this,

      tableKey: "powerBoxTable",
    };
    return formConfig;
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  fetchApi = (param) => {
    if (!this.isFirst) {
      param.stubGroupId = "";
    }
    return param;
  };

  render() {
    return (
      <div>
        <div className="page-toolbar">
          {/* eslint-disable-next-line react/jsx-no-bind */}
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi.bind(this)} />
        </div>
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>
        <Modal
          title={this.state.internationalization.title12}
          visible={this.state.seeDetailVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeDetailVisible", false);
          }}>
          <PowerBoxDetail powerboxInfoData={this.powerboxInfoData} />
        </Modal>
      </div>
    );
  }
}

export default injectIntl(PowerBoxList);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/powerBox/powerBoxList.js